import { getUserDevice } from "../helpers/Utils";
import {rudderanalytics} from "./rudderstack";

function poll(fn, timeout, interval) {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;
  var checkCondition = function(resolve, reject) {
    // If the condition is met, we're done!
    if (rudderanalytics !== undefined) {
      fn();
      resolve();
    }
    // If the condition isn't met but the timeout hasn't elapsed, go again
    else if (Number(new Date()) < endTime && !rudderanalytics) {
      setTimeout(checkCondition, interval, resolve, reject);
    }
    // Didn't match and too much time, reject!
    else {
      reject();
    }
  };
  return new Promise(checkCondition);
}

export function rudderStackTrackEvent(eventName, data) {
  if (rudderanalytics) {
    let payload = {
      ...data,
      event_time: new Date().toISOString(),
      device_type: getUserDevice()
    }
    rudderanalytics.track(eventName, payload);
  }
}

export function eventIdentify(userId, traits) {
  if (rudderanalytics !== undefined) {
    rudderanalytics.identify(`TARS${userId}`, traits);
  } else {
    poll(
      function() {
        rudderanalytics.identify(`TARS${userId}`, traits);
      },
      2000,
      150
    )
      .then(function() {
        // Polling done
      })
      .catch(function(err) {
        // Polling timed out, handle the error!
        console.error("rudderstack sdk error", err);
      });
  }
}

